import { render } from "./ResetWebhooksModal.vue?vue&type=template&id=9aac3a3c"
import script from "./ResetWebhooksModal.vue?vue&type=script&lang=js"
export * from "./ResetWebhooksModal.vue?vue&type=script&lang=js"
script.render = render

export default script